<template>
<v-container fluid>
  <v-layout justify-center>
    <v-flex md12>
        <Solicitud v-if="type == 'Solicitud'" :model="object" :on-success="eventDetails"/>
        <HistoryMovements v-if="type == 'Movements'" :model="object"/>
        <ProcesosDetail v-if="type == 'DetailProcesos'" :model="object"/>
        <EquipoDetail v-if="type == 'DetailEquipo'" :model="object" :on-success="eventDetails"/>
        <Proveedor v-if="type == 'Proveedor'" :model="object"/>
        <Contrato v-if="type == 'Contrato'" :model="object"/>
        <Factura v-if="type == 'Factura'" :model="object"/>
        <Seguimiento v-if="type == 'Seguimiento'" :model="object"/>
        <SolicitudBaja v-if="type == 'SolicitudBaja'" :model="object"/>
        <Solicitudtransferencia v-if="type == 'Solicitudtransferencia'" :model="object"/>
        <SolicitudAlta v-if="type == 'SolicitudAlta'" :model="object"/>
        <ControlDetail v-if="type == 'DetailControl'" :model="object"/>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Solicitud from '@/components/details/SolicitudDetail'
import HistoryMovements from '@/components/details/HistoryMovements'
import EquipoDetail from '@/components/details/EquipoDetails'
import ProcesosDetail from '@/components/details/ProcesosDetail'
import Proveedor from '@/components/details/ProveedorDetail'
import Contrato from '@/components/details/ContratoDetail'
import Factura from '@/components/details/FacturaDetail'
import Seguimiento from '@/components/details/SeguimientoDetail'
import SolicitudBaja from '@/components/details/SolicitudesBajasDetail'
import Solicitudtransferencia from '@/components/details/Solicitudtransferencia'
import SolicitudAlta from '@/components/details/SolicitudAlta'

import ControlDetail from '@/components/details/ControlDetail'
export default {
  props: ['object', 'type', 'actions'],
  data: () => ({
  }),
  mounted () {
  },
  methods: {
    ...mapActions([]),
    eventDetails (item) {
      this.actions(item)
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters([])
  },
  components: {
    Solicitud,
    HistoryMovements,
    EquipoDetail,
    ProcesosDetail,
    Proveedor,
    Contrato,
    Factura,
    Seguimiento,
    SolicitudBaja,
    Solicitudtransferencia,
    SolicitudAlta,
    ControlDetail
  },
  watch: {
  },
  beforeDestroy () {
  }

}
</script>

<style>

</style>
